<template>
  <div class="card"  :style="isOpen ? 'right:0px' : 'right:-30vw'" >
    <div class="card-header bg-white d-flex justify-content-between align-items-center">
      <div class="card-title mb-0">
        <span>{{ $t("demand.financialSituation.summaryOfTheOffer") }} LLD_2022</span>

      </div>

      
        <span @click="toogleSummary">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
          <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
          </svg>
        </span>
  
    </div>
    <div class="card-body">
      <div class="border-bottom mb-2 pb-2">
        <span class="text-primary"> {{ $t("demand.party.roles.CUSTOMER") }} </span>
      <div class="row">
        <div class="col-5"><span class="text-caption text-grey-8"> {{ $t("task.labels.organizationName") }}  :</span></div>
        <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">Singha Beers & wines</span></div>

        <div class="col-5"><span class="text-caption text-grey-8">{{ $t("middleOffice.party.person.identity.phoneNumber") }} :</span></div>
        <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">+33 22 00 00 88</span></div>
      </div>
      </div>
     

      <div v-if="assets" class="border-bottom mb-2 pb-2">
       
      <div  v-for="(asset, index) in assets" :key="asset.id">
        <span class="text-primary">Asset {{ index + 1 }}</span>
        <div class="row">
          <div class="col-5"><span class="text-caption text-grey-8"> {{ $t("middleOffice.party.organization.financialSituation.nature") }}  :</span></div>
          <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right"> {{ $t("demand.asset.vehicle.title") }}</span></div>

          <div class="col-5"><span class="text-caption text-grey-8"> {{ $t("demand.asset.category") }}  :</span></div>
          <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">{{ asset.category.label }}</span></div>

          <div class="col-5"><span class="text-caption text-grey-8">{{ $t("middleOffice.party.organization.financialSituation.label") }} :</span></div>
          <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">{{ asset.brand.label }} {{ asset.model.label }}</span></div>

          <div class="col-5"><span class="text-caption text-grey-8"> {{ $t("demand.asset.vehicle.quantity") }}  :</span></div>
          <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">{{ asset.quantity }}</span></div>

          <div class="col-5"><span class="text-caption text-grey-8"> {{ $t("demand.asset.price") }} HT :</span></div>
          <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">{{ formatNumberWithMask(asset.totalPriceWithDiscount, 2) }}</span></div>

          <div class="col-5"><span class="text-caption text-grey-8"> {{ $t("demand.asset.price") }} TTC :</span></div>
          <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">{{ formatNumberWithMask(asset.totalPriceWithTax, 2) }}</span></div>

        </div>

      </div>
    </div>

    <div class="border-bottom mb-2 pb-2">
      <span class="text-primary"> {{ $t("demand.tabs.financing") }} </span>
      <div class="row">
        <div class="col-5"><span class="text-caption text-grey-8"> {{ $t("middleOfficeFinancingForm.label.financingProduct") }} :</span></div>
        <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">{{ product }}</span></div>

        <div class="col-5"><span class="text-caption text-grey-8">Loyer {{ financingType }} :</span></div>
        <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">{{ formatNumberWithMask(monthlyPayment, 2) }}</span></div>

        <div class="col-5"><span class="text-caption text-grey-8">{{$t("demand.sliders.duration")}} :</span></div>
        <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">{{ duration }}</span></div>

        <div class="col-5"><span class="text-caption text-grey-8">1er loyer {{ financingType }} :</span></div>
        <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">{{ formatNumberWithMask(firstPayment, 2) }}</span></div>

        <div class="col-5"><span class="text-caption text-grey-8">VR :</span></div>
        <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">{{ formatNumberWithMask(residualValue, 2) }}</span></div>

        <div class="col-5"><span class="text-caption text-grey-8"> {{$t("demand.financialSituation.totalInterestCost")}}:</span></div>
        <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">-</span></div>
      </div>
    </div>

    <div class="border-bottom mb-2 pb-2">
      <span class="text-primary">Service</span>
      <div class="row" v-if="!services">
        <div class="col-5"><span class="text-caption text-grey-8">{{ $t("middleOffice.party.organization.financialSituation.label") }} :</span></div>
        <div class="col-7"><span class="text-weight-medium text-grey-8 text-limit text-right">-</span></div>
      </div>
      <div class="row" v-for="item in services" :key="item.id">
        <div class="col-4"><span class="text-caption text-grey-8">{{ item.type.label }} :</span></div>
        <div class="col-8"><span class="text-weight-medium text-grey-8 text-limit text-right">{{ item.name.label }}</span></div>
      </div>
    </div>
    </div>


  </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {ref} from 'vue'
import store from '@/store';
import {formatWithMask} from "@/utils/configuration/formatters-config";

@Options({
  props: ['isOpen'],
  watch: {
  }
})
export default class DemandSimulationSummary extends Vue {
  isOpen: any ;

  get assets() {
    return store.state.demandModule.assetState.proposalAssets
  }

  get price() {
    return store.state.financingModule.proposalAssetTotalWithTax
  }

  get product() {
    return store.state.simulationModule.calculationRequest.financialProductUid.resourceUid
  }

  get financingType() {
    return store.state.simulationModule.isFinancingTypeTTC ? 'TCC' : 'HT'
  }

  get services() {
    return store.state.simulationModule.selectedServices
  }

  get monthlyPayment() {
    if(store.state.simulationModule.simulationBody?.monthlyPayment) {
      return store.state.simulationModule.simulationBody.monthlyPayment
    } else {
      return 0.0
    }
  }

  get firstPayment() {
    if(store.state.simulationModule.simulationBody?.firstPayment) {
      return store.state.simulationModule.simulationBody.firstPayment
    } else {
      return 0.0
    }
  }

  get duration() {
    if(store.state.simulationModule.simulationBody?.duration) {
      return store.state.simulationModule.simulationBody.duration
    } else {
      return 0
    }
  }

  get residualValue() {
    if(store.state.simulationModule.simulationBody?.residualValue) {
      return store.state.simulationModule.simulationBody.residualValue
    } else {
      return 0.0
    }
  }
  formatNumberWithMask(value: number, minDecimal: number){
    return formatWithMask(value, minDecimal)
  }
  toogleSummary() {
    store.state.middleOfficeModule.showSummary = !store.state.middleOfficeModule.showSummary
    store.state.demandModule.showSummary = !store.state.demandModule.showSummary
    store.state.demandModule.showRightSummary = !store.state.demandModule.showRightSummary
  }

}
</script>

